import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import StreamRegistrationForm from "../ones/StreamRegistrationForm";
import OneStudent from '../ones/OneStudent';
import StudentRegistrationForm from "../ones/StudentRegistrationForm";
import MultipleStudentsRegistrationForm from "../ones/MultipleStudentsRegistrationForm";

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [streamStudents, setStreamStudents] = useState(null);
	const [searchFilter, setSearchFilter] = useState("");
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
			getStreamStudents(),
		]);
		setReady(true);
	}

	async function getData() {
		await callApi("get-stream-data", { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	async function getStreamStudents() {
		await callApi("get-stream-students", { uuid }).then(response => {
			if (response.status === 1) {
				setStreamStudents(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && data) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Students for <span className="font-bold">{data.name}</span>
							<br />
              <span className="badge bg-primary">Stream</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Stream Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.name}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Classroom Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.classroomData.name}
						</h6>
					</div>

					

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Number of Students</label>
						<h6
							style={{
								fontSize: "18px",
								margin: "0"
							}}
						>
							{(streamStudents?.length || "0")}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">

							
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_studentRegForm" 
									aria-expanded="false" 
									aria-controls="_studentRegForm"
								>
									<h6
										className="card-title align-self-center"
									>
										Register New Individual Student
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-primary"
									/>
								</div>
								
								<div className="collapse" id="_studentRegForm">
									<hr/>
									<StudentRegistrationForm 
										classroomData={data.classroomData} 
										registrationCallback={getStreamStudents} 
										classroomUuid={data.classroomUuid} 
										suggestedStreamUuid={uuid} 
										classroomStreams={[data]} //only pass this stream alone even if there are many streams
									/>
								</div>
							</div>
							
							
						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">

							
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_studentRegForm2" 
									aria-expanded="false" 
									aria-controls="_studentRegForm2"
								>
									<h6
										className="card-title align-self-center"
									>
										Register Multiple Students
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-primary"
									/>
								</div>
								
								<div className="collapse" id="_studentRegForm2">
									<hr/>
									<MultipleStudentsRegistrationForm 
										classroomData={data.classroomData} 
										registrationCallback={getStreamStudents} 
										classroomUuid={data.classroomUuid} 
										classroomStreams={[data]}
										suggestedStreamUuid={uuid} 
									/>
								</div>
							</div>
							
							
						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="card-title"
										
									>
										Students' List
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										value={searchFilter}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(streamStudents && streamStudents.length > 0) ?
										streamStudents.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.firstName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 ||
													String(item.middleName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 ||
													String(item.lastName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OneStudent data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OneStudent data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No student was found
										</h6>
								}
								
								
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}